import {CLIENT, SSO_DOMAIN, defaultResponseHandler, removeLocal} from "helpers/utils.js";

const defOffset = 0
const defLimit = 50

export async function fetchMe() {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/me`, {
      method: 'GET',
      credentials: 'include'
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error)
    return null;
  }
}

export function handlelogout(closeFn) {
  removeLocal('user');
  fetch(`${SSO_DOMAIN}/v1/logout`, {
    method: 'POST',
    credentials: 'include'
  }).then(res => {
    return res.status === 200
  }).then(data => {
    if (data) {
      closeFn()
    }
  }).catch(err => {
    console.log(err)
  })
}

export async function fetchUsers() {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/clients/${CLIENT}/users`, {
      method: 'GET',
      credentials: 'include'
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function fetchAllUserRefs() {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/clients/${CLIENT}/all-users`, {
      method: 'GET',
      credentials: 'include'
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function fetchUser(userRef) {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/clients/${CLIENT}/users/${userRef}`, {
      method: 'GET',
      credentials: 'include'
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function updateProfile(request) {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/me`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function updateUser(request) {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/clients/${CLIENT}/users`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function registerUser(request) {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/clients/${CLIENT}/register`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function searchUsers(request, offset = defOffset, limit = defLimit) {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/clients/${CLIENT}/search-users?page=${offset}&limit=${limit}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function fetchMyAvatar() {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/avatar`, {
      method: 'GET',
      credentials: 'include'
    });
    if (response.status === 200) {
      // Avatar might be binary data, so we return the response itself
      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function uploadMyAvatar(avatarData) {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/avatar`, {
      method: 'POST',
      credentials: 'include',
      body: avatarData // Assuming FormData or File object
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function fetchMyPlotImage() {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/plot-image`, {
      method: 'GET',
      credentials: 'include'
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function uploadMyPlotImage(blob) {
  const response = await fetch(`${SSO_DOMAIN}/v1/plot-image`, {
    method: 'GET',
    credentials: 'include'
  });
  const data = await defaultResponseHandler(response);
  if (!data || !data.data) {
    throw new Error('Failed to get upload URL');
  }
  const uploadResponse = await fetch(data.data, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/octet-stream'
    },
    body: blob
  });
  if (!uploadResponse.ok) {
    throw new Error(`Failed to upload plot image: ${uploadResponse.status}`);
  }
  return true;
}

export async function fetchAvatar(userRef) {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/clients/${CLIENT}/users/${userRef}/avatar`, {
      method: 'GET',
      credentials: 'include'
    });
    if (response.status === 200) {
      // Avatar might be binary data, so we return the response itself
      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function uploadAvatar(userRef, avatarData) {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/clients/${CLIENT}/users/${userRef}/avatar`, {
      method: 'POST',
      credentials: 'include',
      body: avatarData // Assuming FormData or File object
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function deleteUser(userRef) {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/clients/${CLIENT}/users/${userRef}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function welcomeUsers(userRefsList) {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/clients/${CLIENT}/welcome`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(userRefsList)
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}
